// Shared Constants: Timezone
// This file is the single source of truth for the application timezone.
// It is copied to frontend/src/shared/ and backend/src/shared/ by sync-shared.js
//
// Rota 2.4: bu deger daha once IKI yerde ayri ayri yaziliydi
// (backend/src/utils/timeUtils.js ve frontend/src/utils/timeUtils.ts). Ikisi de
// gun sinirini belirliyor; ayrisirlarsa rapor ile ekran ayni gunu farkli yerden
// baslatir ve hata sessiz olur. Iki tarafin timeUtils'i artik buradan okuyor.
//
// NEDEN SAAT FARKI (+3) DEGIL DE KIMLIK: fark sabit bir sayi degil. Turkiye
// 2016'ya kadar UTC+2 idi ve yaz saati uyguluyordu; sabit bir sayi tutulsaydi
// 2016 oncesi her tarih yanlis hesaplanirdi. Kimlik yazilinca platform o ANA ait
// farki kendisi cozer, yaz saati gecisleri de dahil.
//
// SAAS-COUPLING: uygulamanin tamami tek saat dilimi varsayiyor (TrioCare Turkiye'de)
// — hardcoded — extraction'da bu sabit KIRACI kaydina tasinir (magaza tablosunda
// `zaman_dilimi` kolonu, IANA kimligi, varsayilan 'Europe/Istanbul').
//
// Extraction'da dikkat edilecekler:
//   1. Kiracinin saat dilimi, BAKAN KISININ degil. "Bugunku ciro" isletmenin gunudur;
//      bakanin konumuna gore kayarsa ayni rapor iki kisiye iki farkli toplam gosterir
//      ve gunluk rapor e-postasi ile panel farkli gunu kasteder.
//   2. `timeUtils` bu degeri bugun MODUL SEVIYESINDE sabit tutuyor. Cok kiraciya
//      gecerken parametreye ya da istek basina tasinan baglama donmesi gerekir
//      (`todayTR()` -> `todayTR(kiraciTz)`); 21 backend + 33 frontend dosyasini ilgilendirir.
//   3. Saat dilimi tek basina yetmez: resmi tatil takvimi (shared/utils/holidayHelper,
//      bugun yalniz Turkiye), cron zamanlamalari (jobs/cronJobs.js, bes is),
//      veritabani oturumu (config/db.js) ve SQL icindeki `AT TIME ZONE` ifadeleri
//      (11 sorgu) ayni kiraci degerinden beslenmeli.

export const TIMEZONE = 'Europe/Istanbul';
